import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { chatList } from 'modules/actions/chat';
import { isACtiveFeedbackModal } from 'modules/actions/statusMenu';
import { isACtiveSelectBoxModal } from 'modules/actions/selectBox';
import { isACtiveDementiaBoxModal } from 'modules/actions/dementia';
import IconButton from 'components/atoms/Button/IconButton';
import { device } from 'lib';
import Cold from 'styles/images/logo/cold.png';
import Happy from 'styles/images/logo/happy.png';
import Hot from 'styles/images/logo/hot.png';
import Rain from 'styles/images/logo/rain.png';
import Snow from 'styles/images/logo/snow.png';
import Dongdonge from 'styles/images/logo/dongdonge.png';
/*
 * Happy : 서동이
 * Cold : 추움
 * Hot : 더움
 * Rain : 비
 * Snow : 눈
 */

import {
  SimpleMessage,
  TextMessage,
  ButtonMessage,
  ImageButtonMessage,
  ImageMessage,
  ListCarousel,
  IntroButton,
  Emotion,
  ListButtonDescription,
  ListButton,
  Map,
  SelectBoxButton,
  Suggest,
  Popular,
  OrganizationButton,
  NotMatchCarousel,
  Media
} from '../Templates/index';

/**
 * BotMessage
 */
const BotMessage = ({ boxStyle, item, responseType, index }) => {
  const dispatch = useDispatch();
  const { status, customCode, dialogue_id, message_id } = item;
  const logo_flag = item.logo_flag;

  const onSendMessage = (inStr, action) => {
    let dementiaList;
    if (action === 'url') {
      window.open(inStr);
    } else if (inStr === '치매 자가진단') {
      item.templateMessages.forEach(tempItem => {
        const { id } = tempItem;
        if (id === 'dementia_list') {
          dementiaList = tempItem;
        }
      });
      dispatch(
        isACtiveDementiaBoxModal({
          dementiaboxModal: {
            dementiaStatus: true,
            dementiaList: { dementiaList },
          },
        })
      );
    } else {
      const paramSet = {
        inType: action,
        inStr,
      };
      dispatch(chatList(paramSet));
    }
  };

  const onOpenSelectBox = inStr => {
    let contentOne;
    let trashBagStatus;


    if(inStr === '쓰레기봉투 판매소 위치' || inStr === '동 선택하기' || inStr === '지역을 선택해 주세요.'){
     	if(inStr === '쓰레기봉투 판매소 위치') trashBagStatus = true;
      item.templateMessages.forEach(tempItem => {
        const { id } = tempItem;
        if (id === 'select_One') contentOne = tempItem;
      });
      dispatch(
        isACtiveSelectBoxModal({
          selectboxModal: {
            selectStatus: true,
            selectTitle: inStr,
            contentOne: { contentOne },
            trashBagStatus: { trashBagStatus },
          },
        })
      );
    } else {
      const paramSet = {
        inType: 'query',
        inStr,
      };
      dispatch(chatList(paramSet));
    }
};
/*
    if (inStr !== '대화종료') {
      if (inStr === '쓰레기봉투 판매소 위치') {
        trashBagStatus = true;
      }
      item.templateMessages.forEach(tempItem => {
        const { id } = tempItem;
        if (id === 'select_One') {
          contentOne = tempItem;
        }
      });
      dispatch(
        isACtiveSelectBoxModal({
          selectboxModal: {
            selectStatus: true,
            selectTitle: inStr,
            contentOne: { contentOne },
            trashBagStatus: { trashBagStatus },
          },
        })
      );
    } else {
      const paramSet = {
        inType: 'query',
        inStr,
      };
      dispatch(chatList(paramSet));
    }
*/


  /*
   * url
   */
  const onLink = url => {
    window.open(url);
  };

  /* 로고 */
  const setLogo = flag => {
    let name = '서동이';
    let logo = Happy;
    if (flag === '추움') {
      logo = Cold;
    } else if (flag === '더움') {
      logo = Hot;
    } else if (flag === '비') {
      logo = Rain;
    } else if (flag === '눈') {
      logo = Snow;
    } else if (flag === 'dongdongeYN') {
      logo = Dongdonge;
      name = '동동이';
    } else {
      logo = Happy;
    }
    return (
      <div className="_logo" id="logo" style={{backgroundImage: `url(${logo})`, 'backface-visibility': 'hidden'}}>
        <span>{name}</span>
      </div>
    );
  };

  /*
   * 만족도 && 의견
   */
  const onfeedBackModal = feedId => {
    dispatch(
      isACtiveFeedbackModal({
        feedbackModal: {
          status: true,
          id: feedId,
        },
      })
    );
  };

  const makeKeyVal = (id, idx) => `bot_${id}_${idx}`;

  const setSimpleItem = (message, idx) => {
    if (message) {
      return <SimpleMessage key={makeKeyVal('simple', idx)} item={message} boxStyle={boxStyle} simpleKey={index} name={`simple_${idx}`} />;
    }
    return false;
  };
  /* gif 출력 */
  const setEmotion = (customkey, idx) => {
    const { key } = customkey;
    if (key === 'emo') {
      return <Emotion key={makeKeyVal('emotion', idx)} item={customkey} boxStyle={boxStyle} />;
    }
	if(key === 'video') {
		return <Media key={makeKeyVal('video', idx)} item={customkey} boxStyle={boxStyle} />;
	}
  };
  /* 로고 */
  const setTemplateItem = (tempItem, idx) => {
    const { id } = tempItem;
    const key = makeKeyVal(id, idx);
    if (id === 'textbox') {
      return <TextMessage key={key} item={tempItem} boxStyle={boxStyle} />;
    }
    if (id === 'quick_btn') {
      return <ButtonMessage key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }
    if (id === 'image') {
      return <ImageMessage key={key} item={tempItem} />;
    }
    if (id === 'image_btn') {
      return <ImageButtonMessage key={key} item={tempItem} onClickEvt={onLink} boxStyle={boxStyle} />;
    }
    if (id === 'intro_btn') {
      return <IntroButton key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }
    if (id === 'list_carousel') {
      return (
        <ListCarousel
          key={`bot_${id}_${index}_listC`}
          listKey={`bot_${id}_${index}`}
          item={tempItem}
          onClickEvt={onSendMessage}
          boxStyle={{ width: device() === 'pc' ? 460 : window.innerWidth - 50, margin: 10, height: '320px' }}
        />
      );
    }
    if (id === 'list_btn_desc') {
      return <ListButtonDescription key={key} item={tempItem} boxStyle={{ display: 'flex' }} />;
    }
    if (id === 'list_btn') {
      return <ListButton key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }
    if (id === 'popular_desc') {
      return <Popular key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }
    if (id === 'suggest') {
      return <Suggest key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }
    if (id === 'select_modal') {
      return <SelectBoxButton key={key} item={tempItem} onClickEvt={onOpenSelectBox} boxStyle={boxStyle} />;
    }
    if (id === 'organization_modal') {
      return <OrganizationButton key={key} item={tempItem} boxStyle={boxStyle} />;
    }
    /* not Match시 소통1번가 데이터 */
    if (id === 'search_carousel') {
      return (
        <NotMatchCarousel
          key={`bot_${id}_${index}_notM`}
          listKey={`bot_${id}_${index}`}
          item={tempItem}
          onClickEvt={onSendMessage}
          boxStyle={{ width: device() === 'pc' ? 210 : window.innerWidth - 50, margin: 10, height: '220px' }}
        />
      );
    }
    if (id === 'map+text') {
      return (
        <Map
          key={`bot_${id}_${index}`}
          mapkey={`bot_${id}_${idx}_${index}`}
          item={tempItem}
          boxStyle={{ width: device() === 'pc' ? 460 : window.innerWidth - 50, margin: 10, height: '410px' }}
        />
      );
    }

    /* not used 예시 */
    /*     if (id === 'big_card') {
      return <BigCard key={key} item={tempItem} boxStyle={{ width: 470, margin: 10, height: '410px' }} />;
    }
    if (id === 'small_card') {
      return <SmallCard key={key} item={tempItem} boxStyle={{ width: 230, margin: 10, height: '230px' }} />;
    } */
    return false;
  };

  return (
    <div className="bot_message_div">
      <div className="_chat_name_div">
        <div className="_thumb">{setLogo(logo_flag)}</div>
      </div>
      <div className="_chat_message">
        <div className="_chat_message_set">
          {/* emotion */}
          {item?.customCode?.map((customkey, idx) => {
            return setEmotion(customkey, idx);
          })}

          {item?.messages?.map((message, idx) => {
            return setSimpleItem(message, idx);
          })}

          {/* items Template */}
          {item?.templateMessages?.map((tempItem, idx) => {
            return setTemplateItem(tempItem, idx);
          })}

          {item.createAt && (
            <div className="_chat_message_bottom">
              <div className="_chat_message_bottom_div">
                <div className="_chat_time_div">
                  <div className="_chat_time">{item.createAt}</div>
                </div>
                {status !== 'welcome' && status !== 'quality' && (
                  <div className="_chat_opinion_div">
                    <div className="_chat_opinion" onClick={() => onfeedBackModal(message_id)}>
                      <IconButton icon="ri-mail-send-line" styleDef={{ width: '15px', height: '16px', float: 'left', fontSize: '13px' }} viewStatus="" />
                      의견남기기
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
BotMessage.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  responseType: PropTypes.string,
  index: PropTypes.number,
};
BotMessage.defaultProps = {
  boxStyle: {},
  item: {
    messageId: '',
    emotion: '',
    createAt: '2021.01.01 00:00',
    messages: [],
    templateMessages: [],
  },
  responseType: 'query',
  index: 1,
};

export default BotMessage;
